import { useTranslation } from 'react-i18next';

import { setLanguage, supportedLanguages } from '../i18n';
import { Select } from '../ui';
import { usePreferences } from './preferencesContext';

/**
 * Which language the console shows this person.
 *
 * Applied at once and remembered on their membership, so it follows them to the next desk;
 * the browser's copy is what the sign-in page speaks before anybody has signed in.
 *
 * Lives in the person's menu, beside the theme: a language is somebody's, not the firm's.
 */
export function LanguageSelect({ className = 'w-auto' }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const { save } = usePreferences();

  return (
    <Select
      value={i18n.resolvedLanguage}
      onChange={(event) => {
        void setLanguage(event.target.value);
        save({ language: event.target.value });
      }}
      aria-label={t('language.label')}
      className={className}
    >
      {supportedLanguages.map((language) => (
        <option key={language} value={language}>
          {t(`language.names.${language}`)}
        </option>
      ))}
    </Select>
  );
}
